<template>
    <div class="flex flex-col gap-4 w-full h-full">
        <div class="flex justify-between adaptive-wrapper gap-2 w-full">            
            <div v-if="$currentUser.readOnly" class="header-with-banner">
                <h2 class="text-xl mb-0">Взаиморасчёты</h2>
                <div class="demo-banner">
                Вы находитесь в ознакомительном режиме, в котором запрещено редактировать данные.
                Обратитесь в поддержку за полным функционалом.
                </div>
            </div>
            <h2 v-else class="text-xl mb-0">Взаиморасчёты</h2>
            <!-- <div v-if="showPersonSelect" class="w-full max-w-[360px]">
                <FloatLabel class="w-full max-w-[360px]" variant="in">
                    <AutoComplete 
                        ref="autoCompleteRef" 
                        class="w-full max-w-[360px]" 
                        v-model="currentPerson" 
                        :delay="600" 
                        @item-select="personChange" 
                        inputId="in_label" 
                        dropdown 
                        optionLabel="name" 
                        :suggestions="physicalPersonsList" 
                        @change="onSearchPhysicalPerson"  
                        @blur="restorePreviousPerson" 
                        @click="onFocusInput"
                        @dropdown-click="clearCurrentPerson"
                        @complete="onCompleteSearch"
                        placeholder="Поиск пользователей..." 
                        emptySearchMessage="Пользователь не найден" 
                        :loading="isLoadingPhysicalPersonsList"                        
                    />
                    <label for="in_label">Пользователи</label>
                </FloatLabel>
            </div> -->
        </div>

        <!-- <div v-if="isMobile">
            <Transaction />
        </div> -->
        <!-- <div v-else class="w-full flex flex-column gap-4"> -->
        <div class="w-full flex flex-column gap-4">
            <div v-if="!isMobile" class="w-full flex flex-column">
                <h5>Создание нового перевода</h5>
                <Card class="h-auto w-full">
                    <template #content>                    
                        <Transaction 
                            ref="transactionRef" 
                            :setDefaults="false" 
                            :readOnly="$currentUser.readOnly"
                            direction="row"                             
                            @create="onCreateTransaction" 
                        />
                    </template>
                </Card>
            </div>
            
            <!-- <div class="flex flex-row gap-4 w-full h-full overflow-hidden"> -->
            <div :class="['flex', isMobile ? 'flex-col' : 'flex-row', 'gap-4', 'w-full', 'h-full', 'overflow-hidden']">
            
                <!-- <div class="flex flex-row gap-4 w-full h-[calc(100vh-150px)] overflow-hidden"> -->

                <!-- <div class="flex flex-col basis-[50%] grow-0 gap-2"> -->
                <!-- <div class="flex flex-col w-1/2 h-full overflow-hidden"> -->
                <div :class="['flex', 'flex-col', isMobile ? 'w-full' : 'w-1/2', 'h-full', 'overflow-hidden']">
                    <h5>Текущие взаиморасчеты</h5>
                    <div v-if="isLoading" class="flex justify-center w-full">
                        <Spinner />
                    </div>        

                    <div v-else class="flex-1 overflow-auto">
                    <!-- <div v-else class="flex justify-between gap-4 w-full adaptive-wrapper">               -->
                        <h6 v-if="negativeBalanceList.length === 0 && positiveBalanceList.length === 0" class="text-xl">Взаиморасчёты не найдены</h6>
                        
                        <div v-else >
                            <!-- <div class="basis-[50%] grow-0"> -->
                            <div>
                                <div v-if="isMobile" class="w-full flex flex-column gap-2">
                                    <SelectButton
                                        v-model="tableSelect"
                                        :options="tableSelectList" 
                                        optionValue="value" 
                                        :allowEmpty="false"
                                        class="w-full"
                                    >
                                        <template #option="slotProps">
                                            <div class="flex aligh-center w-full h-full p-2">
                                                <div class="h-full mr-1 mt-0.5">
                                                    <i :class="slotProps.option.icon"></i>
                                                </div>
                                                <h5 class="text-xl mb-0">{{slotProps.option.label}}</h5>
                                            </div>
                                        </template>
                                    </SelectButton>

                                    <p v-if="negativeBalanceList.length === 0 && tableSelect === 'pay' || positiveBalanceList.length === 0 && tableSelect !== 'pay'" >Взаиморасчёты не найдены</p>

                                    <Card v-else class="h-auto w-full mobile-card">
                                        <template #content> 
                                            <div v-if="negativeBalanceList.length > 0 && tableSelect === 'pay'" class="w-full">
                                                <DataTable :value="negativeBalanceList" class="w-full no-rounded-thead" showGridlines :rowStyle="negativeRowStyle" scrollable scrollHeight="calc(100vh - 290px)"> 
                                                    <Column 
                                                        field="T2.name" 
                                                        header="Объект" 
                                                        class="w-1/2"  
                                                        :bodyStyle="{ textAlign: 'center' }"
                                                    ></Column> 
                                                    <Column 
                                                        field="sum" 
                                                        header="Сумма"  
                                                        :bodyStyle="{ textAlign: 'center' }"
                                                    >
                                                        <template #body="slotProps">
                                                            <div :style="{ color: 'red' }">{{ formatNumber(slotProps.data.sum) }}</div>
                                                        </template>
                                                    </Column>  
                                                </DataTable>
                                            </div> 
                                            <div v-if="positiveBalanceList.length > 0 && tableSelect !== 'pay'" class="w-full">
                                                <DataTable :value="positiveBalanceList" class="w-full no-rounded-thead" showGridlines :rowStyle="positiveRowStyle" scrollable scrollHeight="calc(100vh - 290px)"> 
                                                    <Column 
                                                        field="T2.name" 
                                                        header="Объект" 
                                                        class="w-1/2"  
                                                        :bodyStyle="{ textAlign: 'center' }"
                                                    ></Column>  
                                                    <Column 
                                                        field="sum" 
                                                        header="Сумма"  
                                                        :bodyStyle="{ textAlign: 'center' }"
                                                    >
                                                        <template #body="slotProps">
                                                            <div :style="{ color: '#008800'}">{{ formatNumber(slotProps.data.sum) }}</div>
                                                        </template>
                                                    </Column>  
                                                </DataTable>
                                            </div>
                                        </template>
                                    </Card>
                                </div>
                            
                                <Card v-else class="h-auto w-full max-w-[1600px]">
                                    <template #title>
                                        <div class="flex justify-between adaptive-wrapper w-full">
                                            <p v-if="negativeBalanceList.length > 0" class="flex items-center gap-2">
                                                <i class="pi pi-minus-circle minus-icon" /> Платят
                                            </p>
                                            <p v-if="positiveBalanceList.length > 0" class="flex items-center gap-2">
                                                Получают <i class="pi pi-plus-circle plus-icon" />
                                            </p>
                                        </div>
                                    </template>
                                    <template #content> 
                                        <div class="flex justify-between adaptive-wrapper gap-4 w-full">
                                            <div v-if="negativeBalanceList.length > 0" class="flex tables-wrapper">
                                                <DataTable :value="negativeBalanceList" class="w-full no-rounded-thead custom-scroll" showGridlines :rowStyle="negativeRowStyle" scrollable scrollHeight="calc(100vh - 260px)"> 
                                                    <Column 
                                                        field="sum" 
                                                        header="Сумма"  
                                                        :bodyStyle="{ textAlign: 'center' }"                                        
                                                    >
                                                        <template #body="slotProps">
                                                            <div                                                                 
                                                                style="color: red; direction: ltr; cursor: pointer; min-width: 50px"
                                                                @click="onClickSum(slotProps.data)"
                                                            >
                                                                {{ formatNumber(slotProps.data.sum) }}
                                                            </div>
                                                        </template>
                                                    </Column>  
                                                    <Column 
                                                        field="T2.name" 
                                                        header="Объект" 
                                                        class="w-2/3"  
                                                        :bodyStyle="{ textAlign: 'center' }"
                                                    >
                                                        <template #body="slotProps">
                                                            <div
                                                                style="cursor: pointer; min-width: 60px"                                                                 
                                                                @click="onClickPayerObject(slotProps.data)"
                                                            >
                                                                {{ slotProps.data.T2.name }}
                                                            </div>
                                                        </template>
                                                    </Column>  
                                                </DataTable>  
                                                <div class="h-auto w-[1px] divider"/>
                                            </div>
                                            <div v-if="positiveBalanceList.length > 0" class="flex justify-between flex-column w-full tables-wrapper"> 
                                                <DataTable :value="positiveBalanceList" class="no-rounded-thead" showGridlines :rowStyle="positiveRowStyle" scrollable scrollHeight="calc(100vh - 260px)"> 
                                                    <Column 
                                                        field="sum" 
                                                        header="Сумма"  
                                                        :bodyStyle="{ textAlign: 'center' }"
                                                    >
                                                        <template #body="slotProps">
                                                            <div 
                                                                style="color: #008800; cursor: pointer; min-width: 50px"                                                                
                                                                @click="onClickSum(slotProps.data)"
                                                            >
                                                                {{ formatNumber(slotProps.data.sum) }}
                                                            </div>
                                                        </template>
                                                    </Column>  
                                                    <Column 
                                                        field="T2.name" 
                                                        header="Объект" 
                                                        class="w-2/3"  
                                                        :bodyStyle="{ textAlign: 'center' }"
                                                    >
                                                        <template #body="slotProps">
                                                            <div 
                                                                style="cursor: pointer; min-width: 60px"
                                                                @click="onClickReceiverObject(slotProps.data)"
                                                            >
                                                                {{ slotProps.data.T2.name }}
                                                            </div>
                                                        </template>
                                                    </Column>      
                                                </DataTable> 
                                            </div>                            
                                        </div>                        
                                    </template>                    
                                </Card>  
                            </div>         
                                                            
                        </div>
                    </div>
                </div>  
                <!-- <div class="flex flex-col basis-[50%] grow-0 gap-2">                       -->
                <div v-if="!isMobile" class="flex flex-col w-1/2 h-full overflow-hidden min-h-0">
                <!-- <div :class="['flex', 'flex-col', isMobile ? 'w-full' : 'w-1/2', 'h-full', 'overflow-hidden']"> -->
                    <h5>История переводов</h5>
                    <!-- <div class="flex flex-col basis-[50%] justify-between gap-4 adaptive-wrapper w-full">  -->
                        <!-- <div class="flex-1 overflow-auto"> -->
                        <!-- <Card class="h-auto w-full max-w-[1600px]"> -->
                        <Card class="flex flex-col flex-1 w-full max-w-[1650px] min-h-0" style="overflow: hidden;">
                            <template #content>
                                <TransactionTable 
                                    ref="transactionTableRef" 
                                    :readOnly="$currentUser.readOnly"
                                />
                            </template>
                        </Card>                 
                        <!-- </div> -->
                        <!-- <Transaction ref="transactionRef" :setDefaults="false" :direction="row" /> -->
                </div>
            </div>
        </div>
    </div> 

    <!-- <Dialog
        v-model:visible="dialogVisible"
        header="История"
        :modal="true"
        :style="{ width: '70%', height: '70%' }"
    >

    </Dialog> -->
</template> 

<script>
import Transaction from '@/pages/transactions/components/Transaction.vue';
import TransactionTable from '@/pages/transactions/components/TransactionTable.vue';
import { mapGetters } from 'vuex';  
import AutoComplete from 'primevue/autocomplete';
import FloatLabel from 'primevue/floatlabel'; 
import Spinner from '@/components/UI/Spinner.vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Row from 'primevue/row';   
import ColumnGroup from 'primevue/columngroup';
import SelectButton from 'primevue/selectbutton';
import Card from 'primevue/card';
import Dialog from 'primevue/dialog';
import { PhysicalPersonsService } from "@/services/physical-persons"; 
import { UsersService } from "@/services/users.service";
import { isPermitionAllowed } from '@/permissions';
//import { appendAlert } from '@/plugins/alert';

export default {
    name: 'SettlementsPage',
    components: {
        AutoComplete,
        FloatLabel,  
        Spinner, 
        DataTable, 
        Column,
        ColumnGroup,
        Row,
        Card,
        SelectButton,
        Dialog,        
        Transaction,
        TransactionTable,
    },
    data() {
        return {
            isInitialized: false,
            showPersonSelect: false,
            isLoadingPhysicalPersonsList: false,
            allPhysicalPersonsList: [],
            physicalPersonsList: [], 
            currentPerson: null,
            prevCurrentPerson: null, 
            currentUserGuid: null,
            isLoading: true, 
            balanceList: [],
            negativeBalanceList: [],
            positiveBalanceList: [],
            balancePollingInterval: null,
            tableSelect: 'pay',
            tableSelectList: [
                { label: 'Платят', value: 'pay', icon: 'pi pi-minus-circle minus-icon' },
                { label: 'Получают', value: 'receive', icon: 'pi pi-plus-circle plus-icon' },
            ],
            //dialogVisible: false,
        }
    },

    computed: {
        ...mapGetters('ui', ['isMobile']),
        ...mapGetters('user', ['getCurrentPerson']),
    },

    created() {
        this.$store.commit("user/RESET_CURRENT_PERSON_TO_DEFAULT");

        this.currentPerson = this.getCurrentPerson;
        console.log('Текущий выбранный пользователь:', this.currentPerson); 
    }, 

    mounted() {
        this.setUpComponent();
        this.startPolling();
    },
 
    beforeUnmount() {
        this.stopPolling();
    },

    watch: {
        getCurrentPerson: {
            immediate: false,
            handler: async function (newPerson) {
                console.log('Выбранное физлицо:', newPerson);
                
                if (!this.isInitialized) return;

                if (newPerson && this.currentPerson !== newPerson) {
                    this.currentPerson = newPerson;
                    await this.loadBalance();
                }
            }
        }
    },

    methods: {   
        isPermitionAllowed,

        setUpComponent() { 
            this.setOptions();           
        },  

        addFilterToPath() {
            this.$router.push({ 
                path: this.$route.path, 
                query: { 
                    ...this.$route.query,  
                    person_guid: this.currentPerson.guid,
                } 
            }) 
        },

        async loadBalance() {
            try {
                const { data: balanceData } = await PhysicalPersonsService.getBalance(this.currentPerson.guid);
                const sortedBalanceData = balanceData.sort((a, b) => a.sum - b.sum);
                const oldJSON = JSON.stringify(this.balanceList);
                const newJSON = JSON.stringify(sortedBalanceData);
                if (oldJSON !== newJSON) {
                    this.balanceList = sortedBalanceData;
                    this.negativeBalanceList = sortedBalanceData.filter(item => item.sum < 0);
                    this.positiveBalanceList = sortedBalanceData.filter(item => item.sum >= 0).sort((a, b) => b.sum - a.sum);
                }
            } catch (error) {
                console.error('Ошибка при загрузке баланса:', error);
            }
        },

        async setOptions() {
            this.isLoading = true;
            try {
                // const [{ data: physicalPersonResult }, { data: currentUserData }] = await Promise.all([
                //     PhysicalPersonsService.getPesonsList(),
                //     UsersService.getCurrent(),
                // ]);

                // this.currentUserGuid = currentUserData.person_guid;
                // this.allPhysicalPersonsList = physicalPersonResult?.sort((a, b) => a.name.localeCompare(b.name));

                // const personGuid = this.$route.query.person_guid ?? currentUserData.person_guid;
                // const selectedPerson = physicalPersonResult?.find(person => person.guid === personGuid);

                // this.currentPerson = selectedPerson;
                // this.prevCurrentPerson = selectedPerson;

                // if (!this.$route.query.person_guid) {
                //     this.addFilterToPath();
                // }

                // this.showPersonSelect = true;

                if (this.currentPerson) {
                    await this.loadBalance();
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.isInitialized = true;
                this.isLoading = false;
            }
        },

        async onSearchPhysicalPerson(event) { 
            if (event?.value?.length >= 3) {
                this.isLoadingPhysicalPersonsList = true
                try {            
                    const { data: physicalPersonResult } =  await PhysicalPersonsService.getPesonsList(event.value);
                    this.physicalPersonsList = [...physicalPersonResult.sort((a, b) => a.name.localeCompare(b.name))];
                } catch (e) {                
                    this.error = e.message
                    console.log(e)                
                    return
                } finally {
                    this.isLoadingPhysicalPersonsList = false
                }
            } else {
                this.physicalPersonsList = this.allPhysicalPersonsList;
                this.isLoadingPhysicalPersonsList = false
            }
        },

        async personChange(event) {
            this.isLoading = true
            this.prevCurrentPerson = event.value; 
            this.addFilterToPath();  
            this.$refs.autoCompleteRef?.hide();
            await this.loadBalance();  
            this.isLoading = false
        },

        restorePreviousPerson() {
            if (this.prevCurrentPerson && this.currentPerson && this.prevCurrentPerson.guid !==this.currentPerson.guid) {
                this.currentPerson = this.prevCurrentPerson 
            }
            if (!this.currentPerson && this.prevCurrentPerson) {
                this.currentPerson = this.prevCurrentPerson 
            }
            this.$refs.autoCompleteRef?.hide();
        },

        clearCurrentPerson() {
            this.currentPerson = null
            this.physicalPersonsList = [...this.allPhysicalPersonsList];
            this.$refs.autoCompleteRef?.show();
        },

        onFocusInput() {
            this.currentPerson = null;
            this.physicalPersonsList = [...this.allPhysicalPersonsList];
            this.$refs.autoCompleteRef?.show();
        },

        onCompleteSearch() {
           this.physicalPersonsList = [...this.physicalPersonsList]
        },

        startPolling() {
            this.stopPolling(); 
            this.balancePollingInterval = setInterval(() => {
                if (this.currentPerson?.guid) {
                    this.loadBalance();
                }
            }, 5000);  
        },

        stopPolling() {
            if (this.balancePollingInterval) {
                clearInterval(this.balancePollingInterval);
                this.balancePollingInterval = null;
            }
        },

        formatNumber(num) {        
            return this.$formatNumber(num)
        },
        
        negativeRowStyle(data) { 
            return { 
                backgroundColor: 'rgba(136, 0, 0, 0.1)'
            }; 
        },

        positiveRowStyle(data) { 
            return { 
                backgroundColor: 'rgba(0, 136, 0, 0.05)'
            }; 
        },

        onClickPayerObject(rowData) {            
            if (rowData.T2?.type === 'person') {
                this.$refs.transactionRef?.setPayer?.({ guid: rowData.T2.id, name: rowData.T2.name });
            }
        },

        onClickReceiverObject(rowData) {            
            if (rowData.T2?.type === 'person') {
                this.$refs.transactionRef?.setReceiver?.({ guid: rowData.T2.id, name: rowData.T2.name });                
            }
        },

        onClickSum(rowData) {
            //this.dialogVisible = true;
        },    

        // refresh table
        onCreateTransaction() {
            this.$refs.transactionTableRef?.onCreateTransaction();
        },
    }
}

</script>

<style lang="scss" scoped>
 
.adaptive-wrapper {
    flex-direction: row;
}

@media (max-width: 768px) {
    .adaptive-wrapper {
        flex-direction: column;
    }
}

.tables-wrapper {
    width: 50%;
}

@media (max-width: 768px) {
    .tables-wrapper {
        width: 100%;
    }
}
 
::v-deep(.p-datatable-column-header-content) {
    justify-content: center !important;
}

.minus-icon {
    color: #880000;
}

.plus-icon {
    color: #008800;
}

.custom-scroll {
    direction: rtl;
}

@media (max-width: 768px) {
    .custom-scroll {
        direction: ltr;
    }
}

.divider {
    background-color: var(--border-dark);
}

.header-with-banner {
  display: flex;
  align-items: center;
  gap: 16px; /* расстояние между заголовком и плашкой */
}

.demo-banner {
  background-color: #ff5a63;   
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
}

</style>